import { render, staticRenderFns } from "./xieyi.vue?vue&type=template&id=0deeb2d4&scoped=true"
import script from "./xieyi.vue?vue&type=script&lang=js"
export * from "./xieyi.vue?vue&type=script&lang=js"
import style0 from "./xieyi.vue?vue&type=style&index=0&id=0deeb2d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deeb2d4",
  null
  
)

export default component.exports